import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { CompanyService } from '../../services/CompanyService/company';
import { ApiEnvelope } from '../../models/auth.dto';
import { RegisterCompanyRequest } from '../../models/company.dto';
import { CountrySelect } from '../../shared/components/country-select/country-select';

@Component({
  selector: 'app-register-company',
  imports: [CommonModule, FormsModule, RouterLink, CountrySelect],
  templateUrl: './register-company.html',
  styleUrl: './register-company.scss',
})
export class RegisterCompany {
  form: RegisterCompanyRequest = {
    name: '',
    registrationNo: '',
    countryCode: '',
    contactEmail: '',
    contactPhone: '',
    address: '',
    admin: {
      email: '',
      password: '',
      fullName: '',
    },
  };

  isSubmitting = signal(false);
  errorMessage = signal('');
  adminEmailError = signal('');
  successMessage = signal('');
  showPassword = signal(false);
  sameAsContactEmail = signal(false);

  constructor(private companyService: CompanyService) {}

  togglePasswordVisibility(): void {
    this.showPassword.update((v) => !v);
  }

  onContactEmailChange(value: string): void {
    this.form.contactEmail = value;
    if (this.sameAsContactEmail()) {
      this.form.admin.email = value;
      this.adminEmailError.set('');
    }
  }

  onAdminEmailChange(value: string): void {
    this.form.admin.email = value;
    this.adminEmailError.set('');
  }

  toggleSameAsContactEmail(checked: boolean): void {
    this.sameAsContactEmail.set(checked);
    if (checked) {
      this.form.admin.email = this.form.contactEmail;
      this.adminEmailError.set('');
    }
  }

  submit(): void {
    this.errorMessage.set('');
    this.adminEmailError.set('');
    this.isSubmitting.set(true);

    this.companyService.register(this.form).subscribe({
      next: (res) => {
        this.isSubmitting.set(false);
        this.successMessage.set(res.data.message);
      },
      error: (err: HttpErrorResponse) => {
        this.isSubmitting.set(false);
        const body = err.error as ApiEnvelope<unknown> | undefined;
        const message = body?.message ?? 'Registration failed. Please try again.';
        if (body?.code === 'EMAIL_TAKEN') {
          this.adminEmailError.set(message);
        } else {
          this.errorMessage.set(message);
        }
      },
    });
  }
}
